<template>
  <div>
    <b-row>
      <b-col
        cols="9"
        class="mb-1"
      >
        <b-link
          style="font-size: 26px; color: #fff;"
          :to="`/lighting-sub?DeptID=${deptid}`"
        >
          <feather-icon
            style="margin-bottom: 5px;"
            size="34"
            icon="ArrowLeftIcon"
          /> <span style="color: #00FF80;"> ไฟฟ้าส่องสว่าง: </span> {{ waydetail }}
        </b-link>
      </b-col>
      <b-col
        cols="3"
        class="text-sm-right d-flex align-items-center justify-content-end"
      >
        <div class="mr-1">
          <b-dropdown
            id="dropdown-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            right
            text="รายงาน"
            variant="primary"
            class="btn-icon"
          >
            <!-- รายงานอุปกรณ์แต่ละเสา -->
            <b-dropdown-item :href="`/reportpoleday?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปอุปกรณ์แต่ละเสารายวัน
            </b-dropdown-item>
            <b-dropdown-item :href="`/reportpolemonth?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปอุปกรณ์แต่ละเสารายเดือน
            </b-dropdown-item>
            <b-dropdown-item :href="`/reportpoleyear?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปอุปกรณ์แต่ละเสารายปี
            </b-dropdown-item>
            <b-dropdown-divider />
            <!-- รายงานการทำงานตู้ควบคุม -->
            <b-dropdown-item :href="`/reportsemcontrolday?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปการทำงานตู้ควบคุมรายวัน
            </b-dropdown-item>
            <b-dropdown-item :href="`/reportsemcontrolmonth?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปการทำงานตู้ควบคุมรายเดือน
            </b-dropdown-item>
            <b-dropdown-item :href="`/reportsemcontrolyear?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปการทำงานตู้ควบคุมรายปี
            </b-dropdown-item>
            <b-dropdown-divider />
            <!-- รายงานการซ่อมปุกรณ์ -->
            <b-dropdown-item :href="`/reportrepairday?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปการซ่อมอุปกรณ์รายวัน
            </b-dropdown-item>
            <b-dropdown-item :href="`/reportrepairmonth?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปการซ่อมอุปกรณ์รายเดือน
            </b-dropdown-item>
            <b-dropdown-item :href="`/reportrepairyear?wid=${this.$route.query.wid}&type=${this.$route.query.type}`">
              สรุปการซ่อมอุปกรณ์รายปี
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </b-col>
    </b-row>

    <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 610px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
      <b-row>
        <b-col
          lg="12"
          md="12"
        >
          <l-map
            ref="mymap"
            :zoom="zoom"
            :center="center"
            :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false}"
            style="width: 100%; height: 560px; z-index: 0"
            @update:zoom="zoomUpdated"
          >
            <l-tile-layer :url="url" />

            <!-- ไฟส่องสว่าง itemsSemD-->
            <l-marker
              v-for="(marker, index) in markersDetail"
              :key="'marker'+index"
              :ref="'marker'+index"
              :lat-lng="[marker.latitude, marker.longitude]"
              :options="{ autoClose: false, closeOnClick: false }"
              @click="getInfoSemDevice(marker.pole, marker.phase1Volt, marker.phase2Volt, marker.phase3Volt, marker.phase1Amp, marker.phase2Amp, marker.phase3Amp, marker.devstatus, marker.lastseen, marker.id, marker.devconnect)"
            >
              <l-icon
                v-if="marker.devstatus === 'ปกติ'"
                :icon-size="[28, 40]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/icons/Markerlighting.svg')"
              />
              <l-icon
                v-if="(marker.devstatus === 'ปกติ' && marker.devconnect === 'ติดต่อไม่ได้') || (marker.devstatus === 'ดับ' && marker.devconnect === 'ติดต่อไม่ได้')
                  || (marker.devstatus === 'ติดต่อไม่ได้' && marker.devconnect === 'ติดต่อไม่ได้')"
                :icon-size="[28, 40]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/icons/LightingRed.svg')"
              />
              <l-icon
                v-if="marker.devstatus === 'ดับ'"
                :icon-size="[28, 40]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/icons/LightingGrey.svg')"
              />
              <l-popup
                ref="popup"
              >
                <div>
                  <b-img
                    v-if="marker.devstatus === 'ปกติ'"
                    class="mb-1"
                    src="@/assets/images/icons/lighting_icon_map.png"
                  />
                  <b-img
                    v-if="marker.devstatus === 'ดับ'"
                    class="mb-1"
                    src="@/assets/images/icons/lighting_icon_map1.png"
                  /> <span style="font-size: 17px; color:#fff;">ไฟส่องสว่าง</span>
                  <b-table
                    class="table table-borderless"
                    style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                    responsive="lg"
                    :items="itemsSemD"
                    :fields="fieldsSemD"
                    small
                    stacked
                    foot-clone
                  >
                    <template #cell(devstatus)="data">
                      <b-badge
                        :variant="StatusSemD[1][data.value]"
                        style="font-size: 13px;"
                      >
                        {{ StatusSemD[0][data.value] }}
                      </b-badge>
                    </template>
                  </b-table>
                </div>
              </l-popup>
            </l-marker>

            <!-- ตู้ไฟส่องสว่าง -->
            <l-marker
              v-for="(marker, index) in markers"
              :key="'marker'+index"
              :ref="'marker'+index"
              :lat-lng="[marker.latitude, marker.longitude]"
              :options="{ autoClose: false, closeOnClick: false }"
              @click="getInfoSemC(marker.lastseen, marker.devconnect, marker.id)"
            >
              <l-icon
                v-if="marker.devconnect === 'ปกติ'"
                :icon-size="[28, 40]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/icons/LightboxG.svg')"
              />
              <l-icon
                v-if="marker.devconnect === 'ติดต่อไม่ได้'"
                :icon-size="[28, 40]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/icons/LightboxR.svg')"
              />
              <l-popup
                ref="popup"
              >
                <div style="width:auto">
                  <span style="font-size: 17px; color:#fff;">ตู้ควบคุม</span>
                  <b-table
                    class="table table-borderless"
                    style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                    responsive="lg"
                    :items="itemsSemC"
                    :fields="fieldsSemC"
                    small
                    stacked
                    foot-clone
                  >
                    <template #cell(devconnect)="data">
                      <b-badge
                        :variant="StatusSemC[1][data.value]"
                        style="font-size: 13px;"
                      >
                        {{ StatusSemC[0][data.value] }}
                      </b-badge>
                    </template>
                    <template
                      #cell(id)="data"
                    >
                      <a v-b-toggle="'collapse-1'">
                        <div style="display: none">
                          {{ data.value }}
                        </div>
                        <b-img
                          height="45"
                          src="@/assets/images/icons/CDroad/thunder1.svg"
                        />
                      </a>
                      <a
                        v-b-toggle="'collapse-2'"
                      >
                        <b-img
                          height="45"
                          src="@/assets/images/icons/CDroad/thunder2.svg"
                        />
                      </a>
                      <a v-b-toggle="'collapse-3'">
                        <b-img
                          height="45"
                          src="@/assets/images/icons/CDroad/thunder3.svg"
                        />
                      </a>
                      <b-collapse
                        id="collapse-1"
                        v-model="visible[0]"
                      >
                        <div style="width:260px; ">
                          <span style="font-size: 17px; color:#fff; padding-right: 100px;">Phase 1</span>
                          <b-table
                            class="table table-borderless"
                            style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px; padding-right: 100px;"
                            :items="itemsSemBox1"
                            :fields="fieldsSemBox"
                            small
                            stacked
                            foot-clone
                          />
                        </div>
                      </b-collapse>
                      <b-collapse
                        id="collapse-2"
                        v-model="visible[1]"
                      >
                        <div style="width:260px; ">
                          <span style="font-size: 17px; color:#fff; padding-right: 100px;">Phase 2</span>
                          <b-table
                            class="table table-borderless"
                            style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px; padding-right: 100px;"
                            :items="itemsSemBox2"
                            :fields="fieldsSemBox"
                            small
                            stacked
                            foot-clone
                          />
                        </div>
                      </b-collapse>
                      <b-collapse
                        id="collapse-3"
                        v-model="visible[2]"
                      >
                        <div style="width:260px; ">
                          <span style="font-size: 17px; color:#fff; padding-right: 100px;">Phase 3</span>
                          <b-table
                            class="table table-borderless"
                            style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px; padding-right: 100px;"
                            :items="itemsSemBox3"
                            :fields="fieldsSemBox"
                            small
                            stacked
                            foot-clone
                          />
                        </div>
                      </b-collapse>
                    </template>
                  </b-table>
                </div>
              </l-popup>
            </l-marker>
          </l-map>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BLink, BTable, BBadge, BImg, BDropdown, BDropdownItem, BCollapse, BCard, BDropdownDivider,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LIcon, LPopup,
} from 'vue2-leaflet'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BTable,
    BBadge,
    BImg,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    BDropdown,
    BDropdownItem,
    BCollapse,
    BCard,
    BDropdownDivider,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 18,
      center: [0, 0],
      waydetail: '',
      markersDetail: [],
      markers: [],
      deptid: '',
      lat: '',
      lng: '',
      type_name: '',
      itemsSemC: [],
      fieldsSemC: [
        { key: 'lastseen', label: 'อัพเดท:', class: 'text-center' },
        { key: 'devconnect', label: 'สถานะ:', class: 'text-center' },
        { key: 'id', label: '', class: 'text-center' },
      ],
      StatusSemC: [{
        ปกติ: 'ปกติ', ติดต่อไม่ได้: 'ติดต่อไม่ได้',
      },
      {
        ปกติ: 'success', ติดต่อไม่ได้: 'danger',
      }],

      itemsSemD: [],
      fieldsSemD: [
        {
          key: 'pole', label: 'เสาที่:', class: 'text-center',
        },
        {
          key: 'phase1Volt', label: 'Volt Phase1:', class: 'text-center', tdClass: 'bg-light-warning',
        },
        {
          key: 'phase2Volt', label: 'Phase2:', class: 'text-center', tdClass: 'bg-light-warning',
        },
        {
          key: 'phase3Volt', label: 'Phase3:', class: 'text-center', tdClass: 'bg-light-warning',
        },
        {
          key: 'phase1Amp', label: 'AmpPhase1:', class: 'text-center', tdClass: 'bg-light-info',
        },
        {
          key: 'phase2Amp', label: 'Phase2:', class: 'text-center', tdClass: 'bg-light-info',
        },
        {
          key: 'phase3Amp', label: 'Phase3:', class: 'text-center', tdClass: 'bg-light-info',
        },
        { key: 'devstatus', label: 'สถานะ:', class: 'text-center' },
        { key: 'lastseen', label: 'อัพเดท:', class: 'text-center' },
      ],
      StatusSemD: [{
        ปกติ: 'ปกติ', ดับ: 'ดับ',
      },
      {
        ปกติ: 'success', ดับ: 'danger',
      }],

      itemsSemBox1: [],
      itemsSemBox2: [],
      itemsSemBox3: [],
      fieldsSemBox: [
        {
          key: 'watt', label: 'Watt:', tdClass: 'bg-light-warning',
        },
        {
          key: 'kwh', label: 'Kwh:', tdClass: 'bg-light-warning',
        },
        {
          key: 'hz', label: 'Hz:', tdClass: 'bg-light-warning',
        },
        {
          key: 'pf', label: 'Pf:', tdClass: 'bg-light-warning',
        },
      ],
      StatusSemBox: [{
        ปกติ: 'ปกติ', ติดต่อไม่ได้: 'ติดต่อไม่ได้',
      },
      {
        ปกติ: 'success', ติดต่อไม่ได้: 'danger',
      }],
      visible: [],
      ack: '',
    }
  },
  created() {
    this.getCenterSem()
    this.getAlertFireAlarm()
    this.getMarkerSem()
    this.getMarkerSemDevice()
  },
  mounted() {
    const map = this.$refs.mymap.mapObject
    map.addControl(new window.L.Control.Fullscreen())
    this.interval = setInterval(() => {
      this.getAlertFireAlarm()
      this.getMarkerSem()
      this.getMarkerSemDevice()
    }, 10000)
  },
  methods: {
    getAlertFireAlarm() {
      axios
        .post('/checkSemEventLog')
        .then(response => {
          if (response.data.lenght !== 0) {
            this.ack = response.data[0].ack
            this.event = response.data[0].event
            if (this.ack === 1) {
              this.closeAlert()
              this.playSound()
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    playSound() {
      // eslint-disable-next-line global-require
      this.audio = new Audio(require('@/assets/media/alarm.mp3'))
      this.audio.play()
    },
    closeAlert() {
      this.$swal({
        title: `<span style="color:#FFA200;"> Warning </span>
        <span style="color:#000000; font-size: 16px; font-weight: normal"> ${this.event}</span>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          try {
            await axios.post('/closeSemEventLog', { ack: 0 })
            this.$swal({
              icon: 'success',
              title: '<span style="color:#000000">ปิดแจ้งเตือนเรียบร้อยแล้ว</span>',
              showConfirmButton: false,
              timer: 1000,
            })
            this.getMarkerSem()
            this.getMarkerSemDevice()
          } catch (error) {
            this.$swal({
              title: 'Error!',
              text: ' Click to continue!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
        }
      })
    },
    getCenterSem() {
      axios
        .post('/waySEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.center = []
          this.zoom = response.data[0].mapzoom
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
          this.waydetail = response.data[0].detail
          this.deptid = response.data[0].deptid
          this.type_name = response.data[0].type_name
          this.switch.semid = response.data[0].id
        })
        .catch(error => {
          console.log(error)
        })
    },
    getMarkerSemDevice() {
      axios
        .post('/markerSEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.markersDetail = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },

    // ตู้ไฟ
    getMarkerSem() {
      axios
        .post('/markerSEMControl', { wid: this.$route.query.wid })
        .then(response => {
          this.markers = response.data
          this.itemsSemBox1.splice(0)
          this.itemsSemBox2.splice(0)
          this.itemsSemBox3.splice(0)
          // eslint-disable-next-line prefer-destructuring
          this.itemsSemBox1.push(this.markers[0])
          this.itemsSemBox2.push(this.markers[1])
          this.itemsSemBox3.push(this.markers[2])
        })
        .catch(error => {
          console.log(error)
        })
    },
    zoomUpdated(value) {
      setTimeout(() => axios
        .post('/updateMapZoom', {
          mapzoom: value, wid: this.$route.query.wid, type_name: this.type_name,
        })
        .then(response => {
          console.log(response.data)
        })
        .catch(error => {
          console.log(error)
        }), 1000)
    },
    getInfoSemDevice(pole, phase1Volt, phase2Volt, phase3Volt, phase1Amp, phase2Amp, phase3Amp, devstatus, lastseen, id, devconnect) {
      this.itemsSemD = []
      this.itemsSemD.push({
        pole,
        phase1Volt,
        phase2Volt,
        phase3Volt,
        phase1Amp,
        phase2Amp,
        phase3Amp,
        devstatus,
        lastseen,
        id,
        devconnect,
      })
    },

    getInfoSemC(lastseen, devconnect, id) {
      this.itemsSemC = []
      this.itemsSemC.push({
        lastseen,
        devconnect,
        id,
      })
      console.log(this.itemsSemC)
    },
  },
}
</script>

<style lang="scss">
.leaflet-popup-content {
    margin: 10px 10px;
    width: 250px;
    height: 100%;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
    background: rgba(36, 36, 36, 0.95);
    box-shadow: 0 3px 14px rgba(0,0,0,0.4);
    /* Green */
    border: 1px solid #00B058;
    border-radius: 12px 12px 12px 12px;
}
</style>
